import * as React from "react";
import { UitkIcon, UitkIconSize } from "../uitk-react-icons/index.js";
import { UitkLayoutFlexItem } from "../uitk-react-layout-flex/index.js";
import { classNames } from "../uitk-react-utils/index.js";
export class UitkToolbarSecondaryAction extends React.Component {
  static displayName = "UitkToolbarSecondaryAction";
  render() {
    const { actionText, icon, className, disabled, action } = this.props;
    const iconProps = {
      size: UitkIconSize.MEDIUM
    };
    let actionContent;
    if (actionText && icon) {
      console.error(
        "Unable to generate a new component, make sure you are using only one of the actionText or icon as a prop"
      );
      return null;
    }
    if (actionText) {
      actionContent = /* @__PURE__ */ React.createElement("span", null, actionText);
    } else if (icon) {
      actionContent = /* @__PURE__ */ React.createElement(UitkIcon, { name: icon.iconName, title: icon.iconText, id: icon.iconId, ...iconProps });
    } else {
      actionContent = "";
    }
    const content = /* @__PURE__ */ React.createElement("div", { className: classNames("uitk-toolbar-secondary-action-content") }, actionContent);
    const wrapperClassNames = classNames("uitk-toolbar-secondary-action", className);
    const actionElement = actionText || icon ? /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, { className: wrapperClassNames, shrink: 0 }, /* @__PURE__ */ React.createElement("button", { type: "button", disabled, onClick: action }, content)) : null;
    return actionElement;
  }
}
